module.exports = __webpack_public_path__ + "img/phone-2.5c81756e.svg";